import { createSlice, Draft, PayloadAction, current } from "@reduxjs/toolkit";

const initialState: any = {
  openErrorsModal: false,
  templateUnloadings: null,
  templateUnloadingsCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  templateUnloadingsInputValues: {
    date: "",
    type: null,
    employee: null,
    customer: null,
    moreThanMin: null,
  },
  page: 1,
};

export const templateUnloadingsSlice = createSlice({
  name: "templateUnloadings",
  initialState,
  reducers: {
    reducerTemplateUnloadings: (state: Draft<any>, action: PayloadAction<any>) => {
      state.templateUnloadings = action.payload.data.data || [];
      state.templateUnloadingsCount = action.payload.data.count;
      state.limit = action.payload.limit;
      state.page = action.payload.page;
    },
    reducerTemplateUnloadingsLog: (state: Draft<any>, action: PayloadAction<any>) => {
      state.templateUnloadings.error = action.payload.data.data || [];
    },
    reducerTemplateUnloadingsFilters: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.filters = action.payload.data[0];
    },
    reducerTemplateUnloadingsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.templateUnloadingsInputValues = action.payload;
    },
    reducerTemplateOpenErrorsModal: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.openErrorsModal = action.payload;
    },
    reducerTemplateSingleUnloadings: (state: Draft<any>, action: PayloadAction<any>) => {
      const updatedUnloadings = current(state.templateUnloadings).map((unloading: any) => {
        if (unloading.order.id === action.payload.order.id) {
          return { ...unloading, status: action.payload.status };
        }
        return unloading;
      });
      state.templateUnloadings = updatedUnloadings;
    },
    reducerTemplateClearInputValues: () => {
      return initialState;
    },
  },
});

export const {
  reducerTemplateUnloadingsInputValues,
  reducerTemplateUnloadingsFilters,
  reducerTemplateUnloadings,
  reducerTemplateSingleUnloadings,
  reducerTemplateOpenErrorsModal,
  reducerTemplateClearInputValues,
} = templateUnloadingsSlice.actions;

export default templateUnloadingsSlice.reducer;
